import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import CreditCardDisplay from "../../../noc/CreditCardDisplay";
import { LoadingButton } from "@mui/lab";
import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CustomNocPaymentModal = ({
  open,
  onClose,
  displaySuccess,
  onConfirm,
  totalAmount,
  paymentCards,
  activeStep,
  setActiveStep,
  actionText,
  paymentLoading,
  paymentErrorText,
}) => {
  const navigate = useNavigate();
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (displaySuccess && !hasNavigated.current) {
      hasNavigated.current = true;

      setTimeout(() => {
        navigate("/permits/my-permits", {
          state: {
            custom: true,
            cst_packageID: displaySuccess,
          },
        });
      }, 5000);
    }
  }, [displaySuccess, navigate]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {!displaySuccess ? "Complete Your Payment for:" : ""}
      </DialogTitle>
      <Typography variant="h6" color="primary" sx={{ pl: 3 }}>
        {actionText}
      </Typography>
      <DialogContent>
        {displaySuccess ? (
          <>
            <Typography variant="h5" color="success.main" gutterBottom>
              ✅ Payment Successful!
            </Typography>
            <Typography variant="body1" fontWeight="bold" mb={2}>
              Your document(s) is being prepared.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              You will be redirected shortly. You can also view progress anytime
              under <b>My Permit Packages</b>.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body1" mb={2}>
              Please review and complete the payment to proceed.
            </Typography>

            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: 2,
                p: 2,
                mb: 2,
                bgcolor: "#f9f9f9",
                textAlign: "center",
              }}
            >
              <Box sx={{ cursor: "default" }}>
                <CreditCardDisplay
                  cards={paymentCards || []}
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            {!displaySuccess && (
              <Box display="flex" justifyContent="space-between">
                <Typography variant="h6">Total</Typography>
                <Typography variant="h6" color="primary">
                  ${totalAmount?.toFixed(2)}
                </Typography>
              </Box>
            )}
          </>
        )}
      </DialogContent>

      <Typography align="center" color="error">
        {paymentErrorText}
      </Typography>

      {!displaySuccess && (
        <DialogActions>
          <Button onClick={onClose} disabled={paymentLoading}>
            Cancel
          </Button>
          <LoadingButton
            loading={paymentLoading}
            onClick={onConfirm}
            variant="contained"
            color="success"
          >
            Pay ${totalAmount?.toFixed(2)}
          </LoadingButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomNocPaymentModal;
